<template>
  <div class="related-products">
    <div class="container">
      <div class="inner">
        <h2>Une sélection par nos soins</h2>
        <a class="btn btn-black btn-linear" href="/telephones">Voir la boutique</a>
        <div class="glide" ref="slider">
          <div class="glide__track" data-glide-el="track">
            <ul class="glide__slides">
              <li class="glide__slide" v-for="(product, index) in realProducts" :key="index">
                <ProductCard :data="product"/>
              </li>
            </ul>
          </div>
          <div class="glide__arrows" data-glide-el="controls" v-if="realProducts.length > 3">
            <button class="glide__arrow glide__arrow--left" data-glide-dir="<"><span class="fi-rr-arrow-small-left"></span></button>
            <button class="glide__arrow glide__arrow--right" data-glide-dir=">"><span class="fi-rr-arrow-small-right"></span></button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ProductCard from './ProductCard'

import Glide, { Controls, Breakpoints, Swipe } from '@glidejs/glide/dist/glide.modular.esm'
import { mapActions, mapState } from 'vuex'

export default {
  name: 'RelatedProducts',
  data () {
    return {
      slider: null,
      payload: {
        search: '',
        brands: [],
        colors: [],
        storage: [],
        store: '',
        price: {
          min: 0,
          max: 5000
        },
        sort: '',
        perPage: 14,
        page: 1
      }
    }
  },
  mounted () {
    this.payload.brands.push(this.phone.brand.id)
    this.getProducts(this.payload).then(() => {
      this.mountSlider()
    })
  },
  computed: {
    ...mapState({
      loading: state => state.products.loading,
      products: state => state.products.items,
      phone: state => state.phone.item
    }),
    realProducts () {
      const products = []

      this.products.forEach((product) => {
        if(product.id !== this.phone.id) {
          products.push(product)
        }
      })

      return products
    }
  },
  methods: {
    ...mapActions('products', ['getProducts']),
    mountSlider () {
      this.slider = new Glide(this.$refs.slider, {
        type: 'slider',
        bound: true,
        rewind: false,
        perView: 3,
        gap: 31,
        breakpoints: {
          630: {
            perView: 2
          }
        }
      }).mount({ Controls, Breakpoints, Swipe })
    }
  },
  components: {
    ProductCard
  }
}
</script>

<style lang="scss" scoped>
@import '../../../../scss/tools/*';
@import '../../../../scss/mixins/*';

.related-products{
  padding: 40px 0;
  background-color: $white;
  margin-top: 40px;

  .container{
    .inner{
      position: relative;

      a.btn{
        position: absolute;
        right: 0;
        top: -5px;
      }

      & > h2{
        display: inline-block;
        width: 100%;
        font-size: 32px;
        margin-bottom: 50px;
      }

      .glide{
        .glide__track{
          overflow: visible;

          .glide__slides{
            overflow: visible;
          }
        }

        .glide__arrows{
          padding-top: 30px;
          text-align: right;

          @include responsive(tablet){
            text-align: center;
          }

          button{
            border: none;
            background: none;
            padding: 0;
            font-size: 30px;
            color: $primary;
            cursor: pointer;
            margin-left: 10px;

            @include responsive(tablet){
              font-size: 28px;
            }
          }
        }
      }
    }
  }
}
</style>
